module.exports = __webpack_public_path__ + "img/Scooter@2x.83a67e9b.png";